//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  props: {
    url: { type: String, required: true }
  },
  data() {
    return {
      isFullPage: true,
      isLoading: true
    }
  },
  computed: {
    legacyUrl() {
      return `${process.env.legacyUrl}${this.url}?typeSystem=nodejs`
    }
  },
  mounted() {
    this.$nuxt.$on('legacy-height', body => {
      this.$scrollTo('body', 500)
      this.$refs.iframe.height = body.height + 200
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('legacy-height')
  },
  methods: {
    ...mapMutations({
      setLoading: 'loading/loading'
    }),
    onLoadIframe(event) {
      if (event.isTrusted) {
        this.setLoading(false)
        this.isLoading = false
      }
    },
    onUnLoadIframe(event) {
      if (event.isTrusted) {
        this.setLoading(true)
        this.isLoading = true
      }
    }
  }
}
